import { render } from "./ProfileIcon.vue?vue&type=template&id=91528742"
import script from "./ProfileIcon.vue?vue&type=script&lang=js"
export * from "./ProfileIcon.vue?vue&type=script&lang=js"

import "./ProfileIcon.vue?vue&type=style&index=0&id=91528742&lang=scss"
import "./ProfileIcon.vue?vue&type=style&index=1&id=91528742&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__